import ComponentName from '@Constant/componentName'

const crowd = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/my.game',
    redirect: {
      name: ComponentName.myGame.index
    },
    children: [
      {
        component: () => import('../../views/my-game/index.vue'),
        path: 'index',
        name: ComponentName.myGame.index,
        auth: '*',
        meta: {
          title: '我的游戏'
        }
      }
    ]
  }
]

export default crowd
